import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import { SavedECheckEUDDForm } from '../../../payments/components/ECheckEUDD'
import PaymentAlias from '../../../payments/components/common/PaymentAlias'
import { paymentMethodPropType } from '../../../payments/components/common/paymentMethodTypes'
import I18nMessage from '../../../common/I18nMessage'
import { reduceFalseProp } from '../../../../shared/utils/commonUtils'
import '../wallet.components.scss'
import './EditECheckEUDD.scss'

class EditECheckEUDD extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    updateECheck: func.isRequired,
    updateEUDD: func.isRequired,
    setErrorMsg: func.isRequired,
    handleBackView: func.isRequired,
    updatePaymentInfoList: func.isRequired,
  }

  constructor(props) {
    super(props)
    const { paymentMethod } = this.props
    this.state = {
      displayName: paymentMethod && paymentMethod.displayName,
    }
  }

  getPaymentAliasCallBack = value => {
    this.setState({
      displayName: value,
    })
  }

  getSavedECheckEUDDFormCallBack = values => {
    const { displayName } = this.state
    const {
      updateECheck,
      updateEUDD,
      setErrorMsg,
      updatePaymentInfoList,
      paymentMethod,
    } = this.props
    const update = paymentMethod.getJsonType() === 'ECheckPaymentMethod' ? updateECheck : updateEUDD
    const {
      id, billingFirstName, billingLastName, primary, last2Digits, address,
    } = values
    const params = {
      postResource: 'wallet',
      id,
      address: reduceFalseProp({
        ...address, countryCode: address && address.country ? address.country : null,
      }),
      billingFirstName,
      billingLastName,
      displayName: displayName || null,
      last2Digits,
      primary,
    }
    update({
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      params,
      resolve: res => {
        if (res.status === 'FAILURE') {
          setErrorMsg(res.message, res.errorCode)
        } else {
          updatePaymentInfoList(res)
          setErrorMsg(null, null, true)
        }
      },
      reject: ({ message, errorCode }) => {
        setErrorMsg(message, errorCode)
      },
    })
  }

  handleClick = () => {
    this.savedECheckEUDDForm()
  }

  handleCancel = () => {
    const { handleBackView } = this.props
    handleBackView()
  }

  render() {
    const { paymentMethod } = this.props
    const { displayName } = this.state
    const defaultValue = {
      displayName,
    }
    return (
      <div className="passport__wallet__save-echeck-eudd passport__wallet__detail-component passport__wallet__components">
        <h1 className="passport__wallet__edit-echeck-eudd__title passport__wallet__component-title">
          <I18nMessage id="passport.wallet.editECheckEUDD.title" />
        </h1>
        <SavedECheckEUDDForm
          paymentMethod={paymentMethod}
          submitTrigger={submitFunc => {
            this.savedECheckEUDDForm = submitFunc
          }}
          getSavedECheckEUDDFormCallBack={this.getSavedECheckEUDDFormCallBack}
        />
        <PaymentAlias getPaymentAliasCallBack={this.getPaymentAliasCallBack} defaultValue={defaultValue} />
        <ButtonGroup horizontal className="grid passport__wallet__btn">
          <Button type="primary" onClick={this.handleClick}>
            <I18nMessage id="passport.common.btn.update" />
          </Button>
          <Button type="secondary" onClick={this.handleCancel}>
            <I18nMessage id="passport.common.btn.cancel" />
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

export default EditECheckEUDD
